import { render, staticRenderFns } from "./telop.vue?vue&type=template&id=20a639d2&scoped=true&"
import script from "./telop.vue?vue&type=script&lang=js&"
export * from "./telop.vue?vue&type=script&lang=js&"
import style0 from "./telop.vue?vue&type=style&index=0&id=20a639d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a639d2",
  null
  
)

export default component.exports